import './Footer.css';
import { Link } from 'react-router-dom';
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';
import { company } from '../content/companyContent';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section footer-brand">
          <img src="/logo.png" alt={company.legalName} />
          <h3>{company.name}</h3>
          <p>{company.motto}</p>
        </div>

        <div className="footer-section">
          <h3>Contact</h3>
          <p><FaPhoneAlt /> {company.phone}</p>
          <p><FaEnvelope /> {company.website}</p>
          <p><FaMapMarkerAlt /> {company.address}</p>
        </div>

        <div className="footer-section">
          <h3>Services</h3>
          <ul>
            <li><Link to="/services">Blood Collection Centre</Link></li>
            <li><Link to="/services">Ambulance & Emergency Response</Link></li>
            <li><Link to="/services">Healthcare Logistics</Link></li>
            <li><Link to="/services">TPA & Government Empanelment</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Enterprise Support</h3>
          <ul>
            <li><Link to="/services">Hospital Administration</Link></li>
            <li><Link to="/services">Health-Tech Solutions</Link></li>
            <li><Link to="/services">Digital Marketing</Link></li>
            <li><Link to="/services">Medical Tourism</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2026 {company.legalName}. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
